export enum DemographicTile {
  AUDIENCE_FILES = 'tile_audience_files',
  AUDIENCE_SEGMENTS = 'tile_audience_segments',
  CUSTOM_AUDIENCE = 'tile_custom_audience',
  IMPORTED_AUDIENCES = 'tile_imported_audiences',
  LIFESIGHT_DEMOGRAPHICS = 'tile_lifesight_demographics',
  BASE_DEMOGRAPHICS = 'tile_age_gender_income',
  PRIZM_SEGMENTS = 'tile_prizm_segments',
  SCENTRE_PREDEFINED_SEGMENTS = 'tile_scentre_predefined_segments',
}
